import {isLoggedIn} from '@github-ui/client-env'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useEffect} from 'react'

import {MAX_PREHEAT_TASKS, useCachePreheatContext} from './cache-preheat-context'

export type CachePreheatTask = {
  key: string
  task: () => Promise<unknown>
  enabled?: boolean
  highPriority?: boolean
}

export function useCachePreheatTask({key, task, enabled = true, highPriority}: CachePreheatTask) {
  const {markTaskForPreheating} = useCachePreheatContext()
  const preheatingEnabled = !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn()

  useEffect(() => {
    if (!enabled || !preheatingEnabled) return
    markTaskForPreheating(key, task, highPriority)
  }, [enabled, highPriority, key, markTaskForPreheating, preheatingEnabled, task])
}

export function useCachePreheatTasks({tasks}: {tasks: CachePreheatTask[]}) {
  const {markTaskForPreheating} = useCachePreheatContext()
  const preheatingEnabled = !isFeatureEnabled('disable_preheating_for_issues') && isLoggedIn()

  useEffect(() => {
    if (!preheatingEnabled) return
    const enabledTasks = tasks.filter(task => task.enabled !== false).slice(0, MAX_PREHEAT_TASKS)
    for (const task of enabledTasks) {
      markTaskForPreheating(task.key, task.task, task.highPriority)
    }
  }, [markTaskForPreheating, preheatingEnabled, tasks])
}
